import ApiJobsSearchSuggestedTags from 'types/api/JobsSearchSuggestedTags';
import { Option } from 'types/options';

import Model from 'models/Model';

export enum Probabilities {
    High = 'high',
    Mid = 'mid',
    Low = 'low',
}

export default class JobsSearchSuggestedTags implements Model {
    id: string;
    jobTagCount: number;
    name: string;
    probability: Probabilities;
    slug: string;

    constructor(data: ApiJobsSearchSuggestedTags) {
        this.id = data.id;
        this.jobTagCount = data.jobTagCount;
        this.name = data.name;
        this.probability = data.probability;
        this.slug = data.slug;
    }

    getOption = (): Option<JobsSearchSuggestedTags> => {
        return {
            value: this,
            label: this.name,
        };
    };
}